import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;
export class SoilsFields {
  public static controls = {
    title: {
      quantity: null,
      validator: TERMS.NAMES_VALIDATORS,
    },
    axialFriction: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    lateralFriction: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    springStiffness: {
      quantity: UnitConstants.QUANTITY.FORCE_BY_LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    springDamping: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
  };
}
